import React, { useState } from 'react';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import {
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Box,
  withStyles,
} from '@material-ui/core';
import { Link } from 'react-router-dom';

const Accordion = withStyles({
  root: {
    border: '1px solid #ffffff',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
    '&:first-child': {
      'margin-top': '17px',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles(({ breakpoints, spacing }) => ({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    border: '1px solid #ffffff',
    borderLeft: 0,
    borderRight: 0,
    marginBottom: -1,
    minHeight: 52,
    '&$expanded': {
      minHeight: 52,
    },
    [breakpoints.up('sm')]: {
      paddingLeft: spacing(8),
      paddingRight: spacing(5),
    },
  },
  content: {
    margin: '0',
    '&$expanded': {
      margin: '0',
    },
  },
  expanded: {},
}))(MuiAccordionSummary);

const StyledLink = withStyles(({ breakpoints, spacing }) => ({
  root: {
    alignItems: 'center',
    border: '1px solid rgb(238,238,238)',
    borderLeft: 0,
    borderRight: 0,
    color: 'black !important',
    display: 'flex',
    height: '45px',
    paddingLeft: spacing(3),
    [breakpoints.up('sm')]: {
      paddingLeft: spacing(9),
    },
  },
}))(({ classes, children, ...props }) => (
  <Link {...props} className={classes.root}>{children}</Link>
));

const AccordionDetails = withStyles({
  root: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
  },
})(MuiAccordionDetails);

const List = ({ data = [] }) => {
  const [expanded, setExpanded] = useState();

  return (
    <>
      <Box display={{ sm: 'none' }} mx={4} mb={2} fontSize={14} fontWeight="bold">請選擇您的問題類型</Box>
      <Box display={{ xs: 'none', sm: 'block' }} mx={8} mb={2} fontSize={14} fontWeight="bold">全部主題</Box>
      {
      data.map(({
        title, icon, children, id,
      }) => (
        <Accordion
          expanded={expanded === id}
          key={title}
          onChange={(e, expand) => setExpanded(expand ? id : '')}
          square
        >
          <AccordionSummary>
            <Box display="flex" alignItems="center" width={1}>
              <Box flexGrow={1} display="flex" alignItems="center">
                {icon ? <img src={icon} alt="" width="45" height="45" /> : <HelpOutlineIcon />}
                <Box fontWeight="bold" fontSize={14} ml={1}>{title}</Box>
              </Box>
              <Box flexShrink={0} fontSize={24} fontWeight="bold">{ expanded === id ? '-' : '+' }</Box>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            {
              children.map(({ title: childTitle, icon: childIcon, id: childId }) => (
                <StyledLink to={`/faq/${id}/${childId}`} key={childTitle}>
                  {childIcon ? <img src={childIcon} alt="" width="45" height="45" /> : <HelpOutlineIcon />}
                  <Box fontSize={14} ml={1} color="black">{childTitle}</Box>
                </StyledLink>
              ))
          }
          </AccordionDetails>
        </Accordion>
      ))
    }
    </>
  );
};

export default List;
